import { httpGET, json, encodeParams } from './utils.js';
import { ACTIONS } from '../const';
import { getContent } from './content';
import { getCriteria, selectNext } from '../selectors/search';
import { selectContent } from '../selectors/content';

const fetchResults = (queryText, context, url, doctype) => dispatch => {
    return httpGET(url)
        .then(json)
        .then(blob => {
            dispatch({
                type: ACTIONS.SEARCH_RESULTS,
                payload: {
                    queryText,
                    context,
                    blob,
                    doctype,
                },
            });
        });
};

export const search = (queryText, context = null) => (dispatch, getState) => {
    const criteria = getCriteria(getState());

    if (criteria.queryText === queryText && criteria.context === context) {
        return Promise.resolve({});
    }

    dispatch({
        type: ACTIONS.SEARCH,
        payload: { queryText, context },
    });

    const url = '/api/v3/search/';
    const params = {
        text: queryText,
    };

    const doSearch = params => {
        params.doctype = 'markup';
        const mPromise = dispatch(
            fetchResults(
                queryText,
                context,
                encodeParams(url, params),
                params.doctype
            )
        );

        params.doctype = 'content';
        const cPromise = dispatch(
            fetchResults(
                queryText,
                context,
                encodeParams(url, params),
                params.doctype
            )
        );

        return Promise.all([mPromise, cPromise]);
    };

    if (context) {
        const contentId = parseInt(context, 10);
        const content = selectContent(getState(), contentId);
        if (!content) {
            dispatch(getContent(contentId)).then(content => {
                params['slug'] = content.slug;
                doSearch(params);
            });
            return;
        }
        params['slug'] = content.slug;
    }

    return doSearch(params);
};

export const loadMore = doctype => (dispatch, getState) => {
    const { queryText, context } = getCriteria(getState());
    const url = selectNext(getState(), doctype);

    dispatch(fetchResults(queryText, context, url, doctype));
};



// WEBPACK FOOTER //
// ./src/actions/search.js